import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const RightCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  gap: 20px;
`;

export const OptionValue = styled.label`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;
